/** Custom properties attached to a Plausible event. */
export type PlausibleProps = Record<string, PropValue>;

/** The value types Plausible accepts as a custom property. */
type PropValue = boolean | number | string;

declare global {
	// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
	interface Window {
		plausible?: (name: string, options?: { props?: PlausibleProps }) => void;
	}
}

/**
 * Sends a custom event to Plausible, when the tracker is on the page.
 *
 * The name must match a goal configured for the site, and every property key
 * must be listed under the site's custom properties, or neither shows in the
 * dashboard.
 *
 * @param name The event name.
 * @param props Custom properties to break the goal down by.
 */
export function trackPlausible(name: string, props?: PlausibleProps): void {
	window.plausible?.(name, props && { props });
}
